export default __webpack_public_path__ + "static/media/seperatorIcon.e671c391.svg";